var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25380_6308)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.125,
    cy: 7.875,
    rx: 4.125,
    ry: 4.125,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 2.375C11.1049 2.375 13.625 4.89511 13.625 8C13.625 11.1049 11.1049 13.625 8 13.625C4.89511 13.625 2.375 11.1049 2.375 8C2.375 4.89511 4.89511 2.375 8 2.375Z",
    fill: "#E0DEE5",
    stroke: "#6E6E84",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8669 5.13765C10.7819 5.05244 10.6664 5.00455 10.5461 5.00455C10.4257 5.00455 10.3103 5.05244 10.2253 5.13765L8 7.35836L5.77474 5.1331C5.68972 5.04789 5.5743 5 5.45392 5C5.33355 5 5.21813 5.04789 5.13311 5.1331C4.95563 5.31057 4.95563 5.59726 5.13311 5.77474L7.35836 8L5.13311 10.2253C4.95563 10.4027 4.95563 10.6894 5.13311 10.8669C5.31058 11.0444 5.59727 11.0444 5.77474 10.8669L8 8.64164L10.2253 10.8669C10.4027 11.0444 10.6894 11.0444 10.8669 10.8669C11.0444 10.6894 11.0444 10.4027 10.8669 10.2253L8.64164 8L10.8669 5.77474C11.0398 5.60181 11.0398 5.31057 10.8669 5.13765Z",
    fill: "#6E6E84"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25380_6308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.b556be6b.svg";
export { ForwardRef as ReactComponent };